// T041: Create validation utilities

/**
 * Validates a Steemit username
 */
export function isValidUsername(username: string): boolean {
  return /^[a-z][a-z0-9-]{2,15}$/.test(username)
}

/**
 * Validates a tag
 */
export function isValidTag(tag: string): boolean {
  return /^[a-z0-9-]{2,24}$/.test(tag)
}

/**
 * Validates and normalizes tags
 */
export function validateTags(tags: string[]): string[] {
  return tags
    .map((t) => t.toLowerCase().trim())
    .filter(isValidTag)
    .slice(0, 5) // Max 5 tags
}

/**
 * Validates post content length
 */
export function isValidPostLength(content: string): boolean {
  const length = content.length
  return length >= 1 && length <= 65536 // 64KB max
}

/**
 * Validates comment content
 */
export function isValidCommentLength(content: string): boolean {
  const length = content.length
  return length >= 1 && length <= 65536
}

/**
 * Validates image URL
 */
export function isValidImageUrl(url: string): boolean {
  try {
    const parsed = new URL(url)
    return (
      (parsed.protocol === 'http:' || parsed.protocol === 'https:') &&
      /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(parsed.pathname)
    )
  } catch {
    return false
  }
}

/**
 * Validates RC percentage threshold
 */
export function hasEnoughRC(percentage: number, minThreshold: number = 10): boolean {
  return percentage >= minThreshold
}

/**
 * Validates private key format (WIF)
 */
export function isValidPrivateKey(key: string): boolean {
  // Basic WIF format check - starts with 5 and is 51 characters
  return /^5[HJK][1-9A-HJ-NP-Za-km-z]{49}$/.test(key)
}
